<div class="layout-breadcrumb-container p-d-flex p-jc-between p-ai-center p-shadow-1">
    <p-breadcrumb [model]="items" [home]="home" styleClass="layout-breadcrumb p-pl-4 p-py-2"></p-breadcrumb>
    <div class="layout-breadcrumb-buttons p-d-flex p-ai-center p-pr-3">
        <!--<button pButton pRipple type="button" icon="pi pi-cloud-upload" class="p-button-rounded p-button-text p-button-plain p-mr-1"></button>
        <button pButton pRipple type="button" icon="pi pi-bookmark" class="p-button-rounded p-button-text p-button-plain p-mr-1"></button>
        <button pButton pRipple type="button" icon="pi pi-power-off" class="p-button-rounded p-button-text p-button-plain p-mr-1"></button> -->
    </div>
</div>
